<template>
    <a class="nav-link">{{dimension.nombre}}</a>
</template>
<script>
export default {
    props: ['dimension'],
}
</script>

